module.exports = __webpack_public_path__ + "static/img/HuoLiangTongJiJiaShiCang.f251ecd1.jpg";